export default __webpack_public_path__ + "static/media/DemandResponse.f94202e8.svg";